import { Select, Skeleton } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getAgreementByStatus,
  getTotalAgreementsList,
} from "../../utilities/apis/agreements";
import { loadingStates } from "../../utilities/utilities";

function AgreementGraph({ configs, year, setYear }) {
  const allMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const agreementByMonth = configs?.data?.agreementByMonth || [];
  const data = allMonths.map((month) => {
    const monthData = agreementByMonth.find((el) => el.month === month);
    return monthData ? monthData["_count"].id : 0;
  });

  const currentYear = new Date().getFullYear();

  const availableYears = Array.from({ length: 6 }, (_, i) =>
    String(currentYear - 5 + i),
  );

  return (
    <div className="w-full h-full">
      <div className="w-full h-full flex flex-col">
        <Select
          value={String(year)}
          className="w-40"
          data={availableYears}
          onChange={(val) => setYear(Number(val))}
        />
        <div className="mt-4 ml-2 text-slate-600 font-medium">
          Monthly Stats
        </div>
        {configs.loading === loadingStates.LOADING && (
          <Skeleton style={{ height: "200px" }} className="mt-4 mx-8" visible />
        )}
        {configs.loading === loadingStates.NO_ACTIVE_REQUEST &&
          configs.data.agreementByMonth && (
            <div
              className="w-full mt-4"
              style={{
                height: "320px",
              }}
            >
              <Bar
                data={{
                  labels: allMonths,
                  datasets: [
                    {
                      label: "contracts",
                      backgroundColor: "#1b6f8d",
                      barThickness: 30,
                      barPercentage: 0.5,
                      borderRadius: 10,
                      data: data,
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  plugins: {
                    legend: {
                      position: "top",
                      display: false,
                    },
                    datalabels: {
                      anchor: "end",
                      align: "end",
                      formatter: (value) => (value > 0 ? value : ""),
                      color: "#fff",
                    },
                  },
                  scales: {
                    y: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        text: "contracts",
                      },
                      grid: {
                        display: false,
                      },
                      ticks: {
                        display: false,
                      },
                    },
                    x: {
                      beginAtZero: true,
                      title: {
                        display: true,
                        text: "month",
                      },
                      grid: {
                        display: false,
                      },
                    },
                  },
                }}
              />
            </div>
          )}
      </div>
    </div>
  );
}

export default AgreementGraph;
